import { useCallback, useEffect, useMemo, useState } from 'react'
import { fetchCharacterWounds } from '../../../services/wounds.api'
import { WOUND_SEVERITY_LABELS } from './woundZones'

/**
 * Heridas activas y cicatrices de un personaje, más el mapa zona → herida
 * que consume el overlay del maniquí.
 */
export default function useCharacterWounds(slug) {
  const [state, setState] = useState(null)

  const refresh = useCallback(async () => {
    if (!slug) return
    try {
      setState(await fetchCharacterWounds(slug))
    } catch {
      setState(null)
    }
  }, [slug])

  useEffect(() => {
    refresh()
  }, [refresh])

  const active = state?.active || null

  const woundZones = useMemo(() => {
    if (!active) return {}
    const label = active.severityLabel || WOUND_SEVERITY_LABELS[active.severity] || ''
    return (active.zones || []).reduce((acc, z) => {
      acc[z.zone] = { severity: active.severity, label, text: z.text || '' }
      return acc
    }, {})
  }, [active])

  return { state, active, scars: state?.scars || [], woundZones, refresh, setState }
}
